import {PartialRouting} from '../partial-routing';

export class RoutingDashboard extends PartialRouting {
    constructor(base: string = '') {
        super(base);
    }
}
